import styled                                                       from "styled-components";
import {ANIMATION_SEC, black, DEFAULT_SHADOW, white, Z_INDEX_MODAL} from "../globalStyles";

export const StyledHintWrapper = styled.div`
  margin-left: 1rem;
  position: relative;
  
  .iconButton svg {
    width: 1.4rem;
    height: 1.4rem;
  }

  .iconButton:hover + .doc-hint {
    opacity: 1;
    height: unset;
    overflow: unset;
    padding: 1rem;
  }
`;

export const StyledRedHintWrapper = styled.div`
  margin-left: 0;
  position: relative;
  width: 2rem;
    display: inline-block;
  
  .iconButton svg {
    width: 1.6rem;
    height: 1.6rem;
  }

  .iconButton:hover + .doc-hint {
    opacity: 1;
    height: unset;
    overflow: unset;
    padding: 1rem;
  }
`;

export const StyledDocsHint = styled.span<{isLeft: boolean}>`
  display: block;
  font-size: 1.2rem;
  line-height: 2rem;
  color: ${black};
  font-weight: normal;
  box-sizing: border-box;
  max-width: 50rem;
  min-width: 30rem;
  position: absolute;
  transform: ${({isLeft}) => isLeft ? "translate(1rem, 1rem)" : "translate(calc(-100% + 1rem), 1rem)"};
  background-color: ${white};
  box-shadow: ${DEFAULT_SHADOW};
  z-index: ${Z_INDEX_MODAL};
  
  white-space: normal;
  
  opacity: 0;
  height: 0;
  padding: 0;
  overflow: hidden;
  
  transition: opacity ${ANIMATION_SEC}s;


  @media screen and (max-width: 767px) {
    display: none;
  }
  
`;